import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import actionCreators from "../../actionCreators/index.js";
import TransactionDetails from "./transactionDetails";

function mapStateToProps(state) {
  return {
    domainDetails: state.domainDetails,
    discountPrograms: state.transactions.discountPrograms,
    transactions: state.transactions,
    bids: state.bids,
    transactionRequest: state.transactionRequest,
    salesPersonId: state.transactions.salePersonID,
    userDetails: state.userDetails,
    salesPerson: state.salesPerson,
    relatedDealerAccount: state.dealerAccount.accounts,
    paymentMethod: state.paymentMethod,
    errorFields: state.onSubmitDetails.errorFields,
    errorFlag: state.onSubmitDetails.errorFlag,
    isSimulateMode: state.isSimulateMode,
    simulatedUserDetails: state.simulatedUserDetails,
    actionType: state.actionType,
    parentDealerAccountId: state.dealerAccount,
    texts: state.translatedTexts,
    dealerAccount: state.dealerAccount,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(TransactionDetails);
